import { TFunction } from '_metronic/i18n/Metronici18n'
import { OrigemTriagem } from '../../../../triagem/core/_models'

/** Rótulos em pt-BR do que a API entrega por código. Código desconhecido cai no próprio código. */
const ORIGENS: Record<OrigemTriagem, string> = {
  FORMULARIO: 'triagem.origem.formulario',
  REAVALIACAO: 'triagem.origem.reavaliacao',
  NOVO_ENVIO: 'triagem.origem.novo_envio',
}

/** Códigos do catálogo de variáveis do backend que têm rótulo próprio no pt-br.json. */
const VARIAVEIS = [
  'paciente.idade_anos',
  'paciente.idade_meses',
  'paciente.sexo',
  'atendimento.tipo',
]

export const rotuloOrigem = (t: TFunction, origem?: OrigemTriagem): string =>
  origem && ORIGENS[origem] ? t(ORIGENS[origem]) : origem || '-'

export const rotuloVariavel = (t: TFunction, codigo: string): string =>
  VARIAVEIS.includes(codigo) ? t(`triagem.variavel.${codigo}`) : codigo

export const textoValorVariavel = (valor: unknown): string => {
  if (valor === null || valor === undefined) {
    return '-'
  }
  return Array.isArray(valor) ? valor.join(', ') : String(valor)
}

/** Aviso que aparece no card quando chega uma triagem nova com o teleatendimento aberto. */
export const avisoNovaTriagem = (t: TFunction, origem?: OrigemTriagem): string =>
  origem === 'NOVO_ENVIO' ? t('triagem.novo_envio') : t('triagem.nova_reavaliacao')
